<script>
export default {
    name: 'MenuFinanceiro',
    props: {
        me: null
    }
};
</script>

<template>
    <li class="dropdown mega-dropdown" v-if="me.admin || me.acesso_financeiro">
        <a href="#" class="dropdown-toggle menu-financeiro-toggle"  data-toggle="dropdown">
            <i class="fa fa-money"></i> FINANCEIRO <span class="caret"></span>
        </a>
        <ul class="dropdown-menu mega-dropdown-menu menu-financeiro-dropdown">
            <li class="col-sm-4 menu-section">
                <div class="section-wrapper">
                    <div class="section-header" style="padding-left: 15px;">
                        <i class="fa fa-exclamation-triangle text-warning"></i>
                        <h5 class="dropdown-header">Problemas</h5>
                    </div>
                    <ul class="section-items">
                        <li v-if="me.admin || me.financeiro.boleto_nao_registrado" class="menu-item">
                            <a href="#/financeiro/boletos-nao-registrados" class="item-link">
                                <i class="fa fa-file-text-o"></i>
                                <span>Boletos não registrados</span>
                            </a>
                        </li>
                        <li v-if="me.admin || me.financeiro.cliente_sem_cobranca" class="menu-item">
                            <a href="#/financeiro/cliente-sem-cobranca" class="item-link">
                                <i class="fa fa-user-times"></i>
                                <span>Clientes sem cobrança</span>
                            </a>
                        </li>
                        <li v-if="me.admin || me.financeiro.cliente_sem_cobranca" class="menu-item">
                            <a href="#/financeiro/veiculos-sem-cobranca" class="item-link">
                                <i class="fa fa-car"></i>
                                <span>Veículos sem cobrança</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            
            <li class="col-sm-4 menu-section">
                <div class="section-wrapper">
                    <div class="section-header" style="padding-left: 15px;">
                        <i class="fa fa-bar-chart text-info"></i>
                        <h5 class="dropdown-header">Relatórios</h5>
                    </div>
                    <ul class="section-items">
                        <li v-if="me.admin || me.financeiro.boletos_mensais" class="menu-item">
                            <a href="#/financeiro/boletos-mensais" class="item-link">
                                <i class="fa fa-calendar"></i>
                                <span>Boletos mensais</span>
                            </a>
                        </li>
                        <li v-if="me.admin || me.financeiro.boletos_pagos" class="menu-item">
                            <a href="#/financeiro/boletos-pagos" class="item-link">
                                <i class="fa fa-check-circle"></i>
                                <span>Boletos pagos</span>
                            </a>
                        </li>
                        <li v-if="me.admin || me.financeiro.boletos_vencidos_nao_pagos" class="menu-item">
                            <a href="#/financeiro/boletos-vencidos" class="item-link">
                                <i class="fa fa-clock-o"></i>
                                <span>Boletos vencidos e não pagos</span>
                            </a>
                        </li>
                        <li v-if="me.admin || me.financeiro.previsao_financeira" class="menu-item">
                            <a href="#/financeiro/prognostico-financeiro" class="item-link">
                                <i class="fa fa-line-chart"></i>
                                <span>Previsão financeira</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            
            <li class="col-sm-4 menu-section">
                <div class="section-wrapper">
                    <div class="section-header" style="padding-left: 15px;">
                        <i class="fa fa-file-pdf-o text-success"></i>
                        <h5 class="dropdown-header">Nota Fiscal</h5>
                    </div>
                    <ul class="section-items">
                        <li class="menu-item">
                            <a :href="'#/financeiro/notas-mensais'" class="item-link">
                                <i class="fa fa-files-o"></i>
                                <span>Notas Mensais</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </li>
</template>

<style scoped>
/* Menu Toggle */
.menu-financeiro-toggle {
    transition: all 0.3s ease;
}

.menu-financeiro-toggle:hover {
    background-color: rgba(255, 255, 255, 0.1) !important;
    transform: translateY(-1px);
}

/* Mega Dropdown */
.menu-financeiro-dropdown {
    min-width: 600px;
    padding: 0;
    border: none;
    border-radius: 8px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    overflow: hidden;
}

/* Section Styling */
.menu-section {
    border-right: 1px solid #e9ecef;
    padding: 0;
}

.menu-section:last-child {
    border-right: none;
}

.section-wrapper {
    padding: 20px 15px;
    height: 100%;
    transition: background-color 0.3s ease;
}

.section-wrapper:hover {
    background-color: rgba(248, 249, 250, 0.8);
}

/* Section Header */
.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 2px solid #e9ecef;
}

.section-header i {
    font-size: 18px;
    margin-right: 8px;
}

.section-header h5 {
    margin: 0;
    font-weight: 600;
    font-size: 15px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #495057;
}

/* Section Items */
.section-items {
    list-style: none;
    padding: 0;
    margin: 0;
}

.menu-item {
    margin-bottom: 5px;
}

.item-link {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    text-decoration: none;
    color: #6c757d;
    border-radius: 6px;
    transition: all 0.3s ease;
    font-size: 14px;
    border-left: 3px solid transparent;
}

.item-link:hover {
    background-color: #e3f2fd;
    color: #1976d2;
    text-decoration: none;
    transform: translateX(5px);
    border-left-color: #1976d2;
    box-shadow: 0 2px 8px rgba(25, 118, 210, 0.15);
}

.item-link i {
    font-size: 15px;
    margin-right: 10px;
    width: 18px;
    text-align: center;
    opacity: 0.7;
    transition: opacity 0.3s ease;
}

.item-link:hover i {
    opacity: 1;
}

.item-link span {
    flex: 1;
    font-weight: 500;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .menu-financeiro-dropdown {
        min-width: 100%;
        max-width: 100%;
    }
    
    .menu-section {
        border-right: none;
        border-bottom: 1px solid #e9ecef;
    }
    
    .menu-section:last-child {
        border-bottom: none;
    }
}

/* Animation for dropdown opening */
.menu-financeiro-dropdown {
    animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Custom colors for different sections */
.menu-section:nth-child(1) .item-link:hover {
    background-color: #fff3cd;
    color: #856404;
    border-left-color: #ffc107;
}

.menu-section:nth-child(2) .item-link:hover {
    background-color: #d1ecf1;
    color: #0c5460;
    border-left-color: #17a2b8;
}

.menu-section:nth-child(3) .item-link:hover {
    background-color: #d4edda;
    color: #155724;
    border-left-color: #28a745;
}
</style>
